import script from "./WelfareTips.vue?vue&type=script&setup=true&lang=js"
export * from "./WelfareTips.vue?vue&type=script&setup=true&lang=js"

import "./WelfareTips.vue?vue&type=style&index=0&id=906de068&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-906de068"]])

export default __exports__